import AOTourPrivateRequestInteractions from '@html/_common/private_request/private_request_interactions';
import { sendGoogleEvent } from '@html/_common/utils';

const EVENT_CATEGORY = 'CLP - Media With Text';
const POPUP_ACTION = 'Group Enquiry - Submit ';

export default function AOClpPrivateRequest() {
  const initiate = () => {
    const loadPrivateForm = () => {
      const privateOption = new AOTourPrivateRequestInteractions(
        null,
        null,
      );

      privateOption.loadForm();
    };

    $('.js-ao-clp-private-request__cta').on('click', (event) => {
      sendGoogleEvent(EVENT_CATEGORY, POPUP_ACTION, $(event.currentTarget).text());
      loadPrivateForm();
    });

    if (window.location.hash === '#request') {
      loadPrivateForm();
    }
  };

  return { initiate };
}
